<script setup lang="ts">
import Generic from '~/layouts/generic.vue'
import Header from '~/components/Layout/Header.vue'
import Banner from '~/components/Layout/Banner.vue'
import LazyLeadDialog from '~/components/Lead/LeadDialog.vue';
import LazyNewsletterDialog from '~/components/Newsletter/NewsletterDialog.vue';
import { useBannerStore } from '~/stores/useBannerStore';

const { isBannerVisible } = storeToRefs(useBannerStore())
const { loadBrandList } = useBrandStore()
const { loadDisclaimer } = useDisclaimerStore()

useAsyncData('brand-list', async () => loadBrandList())
useAsyncData('disclaimer', async () => loadDisclaimer(), { server: false })
</script>

<template>
  <Generic>
    <!-- WCAG 2.4.1 — Skip Navigation: link visibile solo al focus da tastiera -->
    <a href="#main-content"
      class="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[9999] focus:px-4 focus:py-3 focus:bg-primary focus:text-white focus:font-bold focus:rounded-lg focus:shadow-lg">
      Vai al contenuto principale
    </a>
    <Header />
    <Banner v-if="isBannerVisible" />
    <LazyLeadDialog />
    <LazyNewsletterDialog />
    <Toast position="bottom-center" group="bc" />
    <main id="main-content" tabindex="-1" :class="`${isBannerVisible ? 'mt-28' : 'mt-20'} w-full bg-white`">
      <router-view />
    </main>
  </Generic>
</template>